import { render, staticRenderFns } from "./EditPromotion.vue?vue&type=template&id=4160edcc&scoped=true"
import script from "./EditPromotion.vue?vue&type=script&lang=js"
export * from "./EditPromotion.vue?vue&type=script&lang=js"
import style0 from "./EditPromotion.vue?vue&type=style&index=0&id=4160edcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160edcc",
  null
  
)

export default component.exports